import styled from "styled-components";


const TredingStyleWrapper = styled.section`
  padding: 110px 0;
  background: #131740;

  p {
    margin-bottom: 0;
  }

  .tredingImage_section{
    img{
      max-width: 100%;
      border-radius: 10px;
    }
  }


  .treding_content{
    margin-top: 50px;
  }

  .treding_content_item{
    display: flex;
    margin-bottom: 30px;
    padding-right: 50px;

    .content_item_icon{
      img{
        height: 35px;
        width: 54px;
      }
    }
    .content_item_text{
      margin-left: 30px;
      h4{
        font-size: 22px;
        color: #fff;
        font-weight: 500;
        margin-bottom: 10px;
        text-transform: capitalize;
      }
      p{
        color: #fff;
        text-transform: capitalize;
        font-size: 14px;
      }
    }
  }

  @media (max-width: 991px) {
      .trendingImage_section{
        margin-top: 30px;
      }
  }


  @media (max-width: 767px) {
    padding: 80px 0;

    .tredingImage_section{
      margin-bottom : 30px;
    }

    .treding_content{
      margin-top: 30px;
    }

    .treding_content_item{
      padding-right: 0;
      .content_item_text{
        h4{
          font-size: 20px;
        }
        p{
          font-size: 13px;
        }
      }
    }
  }

  @media (max-width: 575px) {
    .treding_content_item{
      flex-direction: column;
      padding-right: 0;
      text-align: center;

      .content_item_icon{
        margin-bottom: 20px;  
      }
      .content_item_text{
          margin-left: 0;
        h4{
          font-size: 18px;
        }
        p{
          font-size: 12px;
        }
      }
    }
  }

  
`;

export default TredingStyleWrapper;
